module.exports = __webpack_public_path__ + "img/07_bg.4ea500f3.jpg";